<template>
  <div>
    <div v-if="warningZone">
      <h3 class="red">Bij inactiviteit wordt u automatisch uitgelogd!</h3>
    </div>
  </div>
</template>

<script>
export default {
  name: "AutoLogout",

  data: function () {
    return {
      events: ["click", "mouseover", "scroll", "keypress", "load"],
      warningTimer: null,
      logoutTimer: null,
      warningZone: false,
    };
  },
  mounted() {
    this.events.forEach(function (event) {
      window.addEventListener(event, this.resetTimer);
    }, this);

    this.setTimers();
  },

  destroyed() {
    this.events.forEach(function (event) {
      window.removeEventListener(event, this.resetTimer);
    }, this);

    this.resetTimer();
  },

  computed: {},
  methods: {
    setTimers: function () {
      this.warningTimer = setTimeout(this.warningMessage, 30 * 60 * 1000); // 14minutes 14 *60*1000
      this.logoutTimer = setTimeout(this.logOutUser, 32 * 60 * 1000);
      this.warningZone = false;
    },

    logOutUser: function () {
      this.$store.dispatch("auth/logout");
    },

    warningMessage: function () {
      this.warningZone = true;
    },

    resetTimer: function () {
      clearTimeout(this.warningTimer);
      clearTimeout(this.logoutTimer);
      this.setTimers();
    },
  },
};
</script>

<style scoped></style>
